var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPackage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delivery-box 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.7466 3.28567L5.48598 7.003L2.59998 5.583L9.73264 2.061C9.89264 1.97967 10.0846 1.97967 10.2526 2.061L12.7466 3.28567Z",
    fill: "#1D4650"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.392 5.58329L10.004 9.24329L7.23734 7.87996L6.83734 7.67663L14.106 3.95996L14.506 4.16263L17.392 5.58329Z",
    fill: "#1D4650"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.412 10.2977L9.404 17.9997L2.328 14.307C2.128 14.2017 2 13.9904 2 13.763V6.6377L4.99867 8.11503V10.7124C4.99867 11.045 5.27067 11.321 5.59867 11.321C5.92667 11.321 6.19867 11.045 6.19867 10.7124V8.7157L6.59867 8.91036L9.412 10.2977Z",
    fill: "#1D4650"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.992 6.64648L10.612 10.2905L10.604 17.9925L18 14.1305L17.992 6.64648Z",
    fill: "#1D4650"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/package.d83e32b82e634961a1ce1578d687902b.svg";
export { ForwardRef as ReactComponent };